var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":_vm.$vuetify.breakpoint.mobile}},[(_vm.$announcedEvent)?_c('Dates',{attrs:{"currentEvent":_vm.$announcedEvent}}):_vm._e(),_c('Tarifs'),_c('Lieux'),_c('Securite'),_c('Video')],1)}
var staticRenderFns = []

export { render, staticRenderFns }